import React from 'react';
import {
  InternetSlideBackground,
  InternetSlideImgWrapper,
  InternetSlideInfoWrapper,
  InternetSliderBoxWrapper,
  InternetSliderFontDescription,
  InternetSliderFontHeader,
} from '@app/ui/pages/landing-page/slides/internet-slide/internet-slide.styles';
import { BodyWrapper } from '@app/ui/pages/landing-page/body/body.styles';
// import {LayoutLandingPage} from "@app/ui/pages/landing-page/body/body.component";
// import {Box, Typography} from "@material-ui/core";
import { RedButton } from '@app/ui/pages/landing-page/button/button.styles';
import { SlideItemProps } from '@app/ui/pages/landing-page/slides/internet-slide/slide.types';

export const SlideItem: React.FC<SlideItemProps> = (props) => {
  const { description, caption, buttonValue, backgroundImg, onClick } = props;
  return (
    <InternetSlideBackground>
      <InternetSlideImgWrapper background={backgroundImg}>
        <BodyWrapper>
          <InternetSlideInfoWrapper>
            <InternetSliderFontHeader variant='h5'>
              {caption}
            </InternetSliderFontHeader>
            <InternetSliderFontDescription variant='body2'>
              {description}
            </InternetSliderFontDescription>
            <InternetSliderBoxWrapper>
              <RedButton onClick={onClick}>{buttonValue}</RedButton>
            </InternetSliderBoxWrapper>
          </InternetSlideInfoWrapper>
        </BodyWrapper>
      </InternetSlideImgWrapper>
    </InternetSlideBackground>
  );
};
